import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[DynamicModal]'
})
export class DynamicHostDirective {

    constructor(public viewContainerRef: ViewContainerRef) { }

}
